import "@/App.css";
import "@/theme-light.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { SEOHead } from "@/components/SEOHead";
import HomePage from "@/pages/HomePage";
import PackagesPage from "@/pages/PackagesPage";
import GalleryPage from "@/pages/GalleryPage";
import BuilderPage from "@/pages/BuilderPage";
import BookingPage from "@/pages/BookingPage";
import ContactPage from "@/pages/ContactPage";
import ServicesPage from "@/pages/ServicesPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ClientPortalLogin from "@/pages/ClientPortalLogin";
import ClientPortalPage from "@/pages/ClientPortalPage";
import LegalPage from "@/pages/LegalPage";
import { SiteContentProvider } from "@/context/SiteContentContext";

const Layout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const isPortal = location.pathname.startsWith('/portal');

  return (
    <div className="min-h-screen bg-[#0f0f10] text-white">
      <SEOHead />
      {!isAdmin && !isPortal && <Header />}
      <main>{children}</main>
      {!isAdmin && !isPortal && <Footer />}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <SiteContentProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/packages" element={<PackagesPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/design-your-theater" element={<BuilderPage />} />
            <Route path="/book" element={<BookingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/portal" element={<ClientPortalLogin />} />
            <Route path="/portal/dashboard" element={<ClientPortalPage />} />
            <Route path="/privacy-policy" element={<LegalPage docKey="privacy-policy" />} />
            <Route path="/terms/:docKey" element={<LegalPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      </SiteContentProvider>
    </div>
  );
}

export default App;
